import { createAction } from 'redux-actions'

export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN'
export const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN'
export const EDIT_CAMPAIGN = 'EDIT_CAMPAIGN'
export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS'

export const FETCH_DOMAINS = 'FETCH_DOMAINS'

export const FETCH_SERVICES = 'FETCH_SERVICES'
export const CREATE_SERVICE = 'CREATE_SERVICE'
export const EDIT_SERVICE = 'EDIT_SERVICE'

export function createCampaign(data) {
  return (dispatch) => {
    return fetch(`${process.env.REACT_APP_API_HOST}/campaigns`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(createAction(CREATE_CAMPAIGN)(json))
      return json.id
    })
  }
}

export function deleteCampign(campaignId) {
  return (dispatch) => {
    dispatch(createAction(DELETE_CAMPAIGN)(campaignId))
    return fetch(`${process.env.REACT_APP_API_HOST}/campaigns/${campaignId}`, {
      credentials: 'include',
      method: 'DELETE',
    })
  }
}

export function editCampaign(data) {
  return (dispatch) => {
    dispatch(createAction(EDIT_CAMPAIGN)(data))
    return fetch(`${process.env.REACT_APP_API_HOST}/campaigns/${data.id}`, {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify(data),
    })
  }
}

export function fetchCampaigns(options) {
  return (dispatch) => {
    options = options || {}
    const searchParams = new URLSearchParams()
    for (const key in options) {
      searchParams.append(key, options[key])
    }
    return fetch(`${process.env.REACT_APP_API_HOST}/campaigns?${searchParams}`, {
      credentials: 'include',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',
    })
    .then(response => response.json())
    .then(json => {
      dispatch(createAction(FETCH_CAMPAIGNS)(json))
    })
  }
}

export function fetchDomains(options) {
  return (dispatch) => {
    options = options || {}
    const searchParams = new URLSearchParams()
    for (const key in options) {
      searchParams.append(key, options[key])
    }
    return fetch(`${process.env.REACT_APP_API_HOST}/domains?${searchParams}`, {
      credentials: 'include',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',
    })
    .then(response => response.json())
    .then(json => {
      dispatch(createAction(FETCH_DOMAINS)(json))
    })
  }
}

export function fetchServices(options) {
  return (dispatch) => {
    options = options || {}
    const searchParams = new URLSearchParams()
    for (const key in options) {
      searchParams.append(key, options[key])
    }
    return fetch(`${process.env.REACT_APP_API_HOST}/ads?${searchParams}`, {
      credentials: 'include',
      Pragma: 'no-cache',
      'Cache-Control': 'no-cache',
    })
    .then(response => response.json())
    .then(json => {
      dispatch(createAction(FETCH_SERVICES)(json))
    })
  }
}

export function createService(data = {}) {
  return (dispatch) => {
    const searchParams = new URLSearchParams()
    return fetch(`${process.env.REACT_APP_API_HOST}/ads?${searchParams.toString()}`, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify(data),
    })
    .then(response => response.json())
    .then((json) => {
      dispatch(createAction(CREATE_SERVICE)(json))
      return json
    })
    .catch(error => dispatch(createAction(CREATE_SERVICE)(error)))
  }
}

export function editService(data) {
  return (dispatch) => {
    dispatch(createAction(EDIT_SERVICE)(data))
    return fetch(`${process.env.REACT_APP_API_HOST}/ads/${data.id}`, {
      credentials: 'include',
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache',
      },
      body: JSON.stringify(data),
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/ads.js